import { $t } from '@/i18n';
import { getDocLink } from '@utils/links';
import XyPageContainer from './xy-page-container.vue';
import XyPageSchema from './xy-page-schema';
import { XyPageletPropsEditorMeta } from '../uicorePlugin/paramsFormComponents';
import { XyPageContainerTipsMeta, XyInnerPageSelectorMeta, XyInnerPageletSelectorMeta, XyInnerFlowNodePageletConfigMeta } from './meta';

const propPanel = {
  XyInnerPageSelector: XyInnerPageSelectorMeta,
  XyInnerPageletSelector: XyInnerPageletSelectorMeta,
  XyInnerFlowNodePageletConfig: XyInnerFlowNodePageletConfigMeta,
  XyPageletPropsEditor: XyPageletPropsEditorMeta,
  XyPageContainerTips: XyPageContainerTipsMeta,
};

// if (location.href.includes('/pageconfig')) {
//   // 拆包
//   import('./xy-inner-page-selector.vue').then((r) => {
//     propPanel.XyInnerPageSelector = r.meta;
//   });
//   import('./xy-inner-pagelet-selector.vue').then((r) => {
//     propPanel.XyInnerPageletSelector = r.meta;
//   });
//   import('./xy-inner-flow-node-pagelet-config.vue').then((r) => {
//     propPanel.XyInnerFlowNodePageletConfig = r.meta;
//   });
// }

export default {
  component: XyPageContainer,
  componentForDesign: XyPageContainer,
  category: $t('k_94e14a60'),
  id: 'xy-page-container',
  methods: [
    {
      id: 'refresh',
      title: $t('k_9a3e572d'),
      arguments: [],
      returnValue: {},
    },
  ],
  events: [
    {
      id: 'presetEventA',
      name: $t('k_a6129a05'),
      desc: $t('k_aaef185b'),
      arguments: [
        {
          type: 'any',
          description: $t('k_3e0ae0c8'),
        },
      ],
    },
    {
      id: 'presetEventB',
      name: $t('k_e5868a4d'),
      desc: $t('k_aaef185b'),
      arguments: [
        {
          type: 'any',
          description: $t('k_3e0ae0c8'),
        },
      ],
    },
    {
      id: 'presetEventC',
      name: $t('k_81dc7095'),
      desc: $t('k_aaef185b'),
      arguments: [
        {
          type: 'any',
          description: $t('k_3e0ae0c8'),
        },
      ],
    },
    {
      id: 'presetEventD',
      name: $t('k_7a3fc12a'),
      desc: $t('k_aaef185b'),
      arguments: [
        {
          type: 'any',
          description: $t('k_3e0ae0c8'),
        },
      ],
    },
    {
      id: 'presetEventE',
      name: $t('k_8d6b2f84'),
      desc: $t('k_aaef185b'),
      arguments: [
        {
          type: 'any',
          description: $t('k_3e0ae0c8'),
        },
      ],
    },
  ],
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-page-container_1636364657577.png',
  slots: [],
  display: 'block',
  visible: true,
  name: $t('k_288dd50f'),
  readme: getDocLink().PAGELET_DOC ?? '',
  order: 1,
  propPanel,
  propsSchema: XyPageSchema,
  // 预设值
  presets: [],
};
